// @ts-nocheck
/**
 * ToastNotification - Simple toast notification display
 * Extracted from App.tsx for modularization
 */
import React from 'react';

interface ToastNotificationProps {
  message: string | null;
}

export default function ToastNotification({ message }: ToastNotificationProps) {
  if (!message) return null;

  return (
    <div className="toast-notification">
      {message}
    </div>
  );
}
